import { formatPhoneInput, toDateInputValue } from "../../../utils/parcelFormatters";
import { ParcelEditForm } from "../../../services/parcelTypes";

export function toForm(parcel: any): ParcelEditForm {
    return {
        cityLastContactDate: toDateInputValue(parcel.cityLastContactDate),
        cityNextContactDate: toDateInputValue(parcel.cityNextContactDate),
        ownerContactName: parcel.ownerContactName ?? "",
        ownerContactPhone: formatPhoneInput(parcel.ownerContactPhone ?? ""),
        ownerContactEmail: parcel.ownerContactEmail ?? "",
        developmentPlansExist:
            parcel.developmentPlansExist === true
                ? "yes"
                : parcel.developmentPlansExist === false
                    ? "no"
                    : "",
        parcelNotes: parcel.parcelNotes ?? "",
        plannedUse: parcel.plannedUse ?? "",
        plannedDwellingUnits: parcel.plannedDwellingUnits?.toString?.() ?? "",
        plannedCommercialSqft: parcel.plannedCommercialSqft?.toString?.() ?? "",
        plannedTotalSqft: parcel.plannedTotalSqft?.toString?.() ?? "",
        plannedParkingStalls: parcel.plannedParkingStalls?.toString?.() ?? "",
        plannedParkingType: parcel.plannedParkingType ?? "",
        plannedDevelopmentTimeline: parcel.plannedDevelopmentTimeline ?? "",
        cityContacts: Array.isArray(parcel.cityContacts)
            ? parcel.cityContacts.map((c: any) => ({
                id: c.id,
                contactDate: toDateInputValue(c.contactDate),
                staffName: c.staffName ?? "",
                staffCategory: c.staffCategory ?? "",
                notes: c.notes ?? "",
            }))
            : [],
        jobs: parcel.jobs?.toString?.() ?? "",
        buildingValue: parcel.buildingValue?.toString?.() ?? "",
        industry: Array.isArray(parcel.industry)
            ? parcel.industry
                .filter((item: any) => item && typeof item === "object")
                .map((item: any) => ({
                    code: item.code ?? "",
                    name: item.name ?? "",
                }))
                .filter((item: { code: string; name: string }) => item.code && item.name)
            : [],
        estimatedWages: parcel.estimatedWages?.toString?.() ?? "",
    };
}

export function toPayload(form: ParcelEditForm) {
    const numOrNull = (v: string) => {
        const trimmed = v.trim();
        if (trimmed === "") return null;

        const num = Number(trimmed);
        return Number.isFinite(num) ? num : null;
    };

    return {
        cityLastContactDate: form.cityLastContactDate || null,
        cityNextContactDate: form.cityNextContactDate || null,
        ownerContactName: form.ownerContactName || null,
        ownerContactPhone: form.ownerContactPhone || null,
        ownerContactEmail: form.ownerContactEmail || null,
        developmentPlansExist:
            form.developmentPlansExist === "yes"
                ? true
                : form.developmentPlansExist === "no"
                    ? false
                    : null,
        parcelNotes: form.parcelNotes || null,
        plannedUse: form.plannedUse || null,
        plannedDwellingUnits: numOrNull(form.plannedDwellingUnits),
        plannedCommercialSqft: numOrNull(form.plannedCommercialSqft),
        plannedTotalSqft: numOrNull(form.plannedTotalSqft),
        plannedParkingStalls: numOrNull(form.plannedParkingStalls),
        plannedParkingType: form.plannedParkingType || null,
        plannedDevelopmentTimeline: form.plannedDevelopmentTimeline || null,
        cityContacts: form.cityContacts
            .filter((c) => c.staffName.trim() || c.contactDate || c.staffCategory || c.notes.trim())
            .map((c) => ({
                id: c.id,
                contactDate: c.contactDate || null,
                staffName: c.staffName || null,
                staffCategory: c.staffCategory || null,
                notes: c.notes || null,
            })),
        jobs: numOrNull(form.jobs),
        buildingValue: numOrNull(form.buildingValue),
        industry: form.industry
            .filter((item) => item.code.trim() && item.name.trim())
            .map((item) => ({
                code: item.code,
                name: item.name,
            })),
        estimatedWages: numOrNull(form.estimatedWages),
    };
}